import { Middleware } from 'redux'
import { NetworkActionTypes } from 'src/store/network/NetworkActionTypes'

const localStorageMiddleware: Middleware = () => (next) => (action) => {
  if (action.type === NetworkActionTypes.SET_NETWORK) {
    localStorage.setItem(NetworkActionTypes.SET_NETWORK, action.network)
  }
  return next(action)
}

export default localStorageMiddleware
